/**
 * Layout mode breakpoints for Cordexa shells (chat, admin).
 * Phone uses the compact shell (drawers); tablet keeps desktop structure with touch/density CSS.
 */
export const PHONE_MAX_WIDTH_PX = 767;

export const TABLET_MIN_WIDTH_PX = 768;
export const TABLET_MAX_WIDTH_PX = 1366;

export const DESKTOP_MIN_WIDTH_PX = 1024;

/** @deprecated Prefer PHONE_MAX_WIDTH_PX — kept for existing imports */
/** Compact shell (drawers): phones through narrow tablets; not iPad Pro desktop widths. */
export const COMPACT_SHELL_MAX_WIDTH_PX = 1023;

export const phoneMediaQuery = `(max-width: ${PHONE_MAX_WIDTH_PX}px)`;

/** Compact shell: phones and narrow viewports (drawers, mobile header). */
export const compactShellMediaQuery = `(max-width: ${COMPACT_SHELL_MAX_WIDTH_PX}px)`;

/**
 * Tablet density / viewport fixes (touch-friendly spacing, dvh shell tuning).
 * Matches iPad Pro landscape/portrait without forcing phone layout.
 */
export const tabletShellMediaQuery = `(min-width: ${TABLET_MIN_WIDTH_PX}px) and (max-width: ${TABLET_MAX_WIDTH_PX}px)`;

/** Touch tablet: coarse pointer devices at tablet widths (iPad Safari). */
export const touchTabletMediaQuery = `(hover: none) and (pointer: coarse) and (min-width: ${TABLET_MIN_WIDTH_PX}px)`;

/**
 * Hover-capable, fine pointer (mouse or trackpad) at any width - the input
 * capability, deliberately independent of viewport size, for affordances that
 * only a mouse can drive. Width-scoped touch detection lives in
 * `touchTabletMediaQuery` above.
 */
export const finePointerMediaQuery = "(hover: hover) and (pointer: fine)";

export type LayoutMode = "phone" | "tablet" | "desktop";
